<div class="dashboard-container">
  <div class="left-container">
    <h1>{{course.title}}</h1>
    <app-text-card [text]="course.welcome_text"></app-text-card>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>Willkommen</mat-panel-title>
        <mat-panel-description>Informationen zum Kurs</mat-panel-description>
      </mat-expansion-panel-header>
      <p>{{course.welcome_text}}</p>
    </mat-expansion-panel>
    <div class="lesson-card-container">
      @for (lesson of lessons; track lesson; let i = $index) {
        <app-lesson-card
          [imageData]="lesson.imageData ?? './assets/images/Baerchen_winkt.png'" [title]="lesson.title"
          [progress]="lesson.progress ?? 0" [disabled]="!isLessonUnlocked(i)"
          (click)="isLessonUnlocked(i) && navigateToLesson(lesson.id)"
          [tooltip]="!isLessonUnlocked(i) ? 'Erst Lektion ' + lessons[i - 1].title + ' abschließen' : ''">
        </app-lesson-card>
      }
      @if (lessons.length == 0) {
        <h2>Es konnten keine Lektionen geladen werden</h2>
      }
    </div>
    <div class="count-card-container">
      <app-count-card [firstNumber]="amountVideosWatched" [secondNumber]="amountVideos"
      [subTitle]="'Videos gesehen'"></app-count-card>
      <app-count-card [firstNumber]="amountFinishedLessons" [secondNumber]="lessons.length"
      [subTitle]="'Lektionen bearbeitet'"></app-count-card>
    </div>
  </div>
  <div class="app-banner-container">
    <h3>NeoDiary App</h3>
    <p>Der Kurs "{{course.title}}" ist auch in unserer NeoDiary App verfügbar – damit du ihn jederzeit und überall
    nutzen kannst.</p>
    <div class="badge-container">
      <a href="https://apps.apple.com/de/app/neodiary/id6466985522">
        <img decoding="async" src="https://neodiary.app/wp-content/uploads/2023/09/apple-appstore_logo-1-3.png"
        alt=""> </a>
        <a href="https://play.google.com/store/apps/details?id=aiddevs.com.neo_app">
          <img decoding="async" src="https://neodiary.app/wp-content/uploads/2023/09/google-play-badge-1-3-1.png"
          alt=""> </a>
        </div>
      </div>
      <div class="acknowledgements-container">
        <h3>Die Erstellung der App wurde finanziell, konzeptionell und fachlich unterstützt durch:</h3>
        <div class="right-container">
          <div class="circle">
            <img src="./assets/images/DSKN_Logo.jpg" alt="">
          </div>
          <div class="circle">
            <img src="./assets/images/Kurt_Goldstein_Institut_Logo.jpg" alt="">
          </div>
          <div class="circle">
            <img src="./assets/images/Zentrum_für_feto_neonatale_Gesundheit_Logo.png" alt="">
          </div>
        </div>
      </div>
    </div>